module.exports = __webpack_public_path__ + "img/glq.6bb45f57.gif";